export enum Constants {
  AUTH_TOKEN = 'auth-token',
  CURRENT_USER_PHONE_NO = 'current-user-phone-no'
}
